export default __webpack_public_path__ + "static/media/vuesax-linear-calendar.13ab0151.svg";